import { Drawer } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { useFetchContactById } from '@features/contacts/hooks/useFetchContactById'
import { ContactBalancePayment } from '@features/transactions/query-api'

import { useTransactionDrawerContext } from '../../contexts/TransactionDrawerContext'
import { BookingsSection } from '../../elements/BookingsSection/BookingsSection'
import { DetailsSection } from '../../elements/DetailsSection'
import { HeroSection } from '../../elements/HeroSection'
import { Separator } from '../../elements/Separator'
import { TransactionDrawerSkeleton } from '../../elements/TransactionDrawerSkeleton'

interface BankPaymentViewProps {
  contactBalancePayment: ContactBalancePayment
}

export const ContactBalancePaymentView = ({ contactBalancePayment }: BankPaymentViewProps) => {
  const { t } = useTranslation()
  const { transactionNo } = useTransactionDrawerContext()

  const { amount, contactId, currencyId, entryDate, createdTime } = contactBalancePayment
  const { contact, isLoading } = useFetchContactById(contactId)

  if (isLoading) {
    return <TransactionDrawerSkeleton transactionNo={transactionNo} />
  }

  return (
    <>
      <Drawer.Header closable title={t('ledger.drawer_title', { number: transactionNo })} />
      <Drawer.Body withPadding={false} gap="0">
        <HeroSection amount={amount} contactName={contact?.name} currency={currencyId} entryDate={entryDate} />
        <Separator />
        <BookingsSection originatorCurrency={currencyId} />
        <Separator />
        <DetailsSection createdTime={createdTime} />
        <Separator />
      </Drawer.Body>
    </>
  )
}
